import * as React from 'react';

import { Item } from './item';
import { NoResult } from './no-result';

const Component= (props) => {
  const {
    filteredElements,
    activeElementIndex,
    borderRadius,
    setTooltip,
    removeTooltip,
    onClick,
    optionRenderer,
  } = props;
  if (filteredElements.length) {
    return (
      <>
        {
          filteredElements.map((elem, index) => {
            const isActive = index === activeElementIndex;
            return (
              <Item
                key={elem + index}
                element={elem}
                elementId={index}
                isActive={isActive}
                borderRadius={borderRadius}
                onClick={onClick}
                setTooltip={setTooltip}
                removeTooltip={removeTooltip}
                optionRenderer={optionRenderer}
              />
            )
          })
        }
      </>
    )
  } else {
    return <NoResult/>;
  }
}

export const ListContent = React.memo(Component);